module.exports = __webpack_public_path__ + "static/media/paypal-confirm.139a1213.png";